module.exports = __webpack_public_path__ + "static/media/address.6fea2092.svg";